import React from 'react';
import { connect } from 'react-redux';
import { Input, Row, Col } from 'antd';
import CustomerTypes from '../CustomerTypes/CustomerTypes';

const Search = Input.Search;

const TopPanel = props => {
  const {
    typesList,
    stat,
    totalCustomers,
    onChangeTypeList,
    onChangeSearch,
    typeListValue,
    handleSearchCustomers,
  } = props;
  return (
    <div className="b-table-filters">
      <Row>
        <Col span={18}>
          <div className="orders__states">
            <CustomerTypes
              totalCustomers={totalCustomers}
              typesList={typesList}
              stat={stat}
              value={typeListValue}
              onChangeTypeList={onChangeTypeList}
            />
          </div>
        </Col>
        <Col span={6}>
          <Search
            placeholder="Наименование или ИНН"
            onChange={onChangeSearch}
            allowClear={true}
            onSearch={handleSearchCustomers}
            style={{ width: '100%' }}
          />
        </Col>
      </Row>
    </div>
  );
};

export default connect(state => {
  return {
    searchValue: state.Customers.filters.search,
    typeListValue: state.Customers.filters.typeList,
  };
})(TopPanel);
